import isUrl from 'is-url'
import i18next from 'i18next'

export default value => value => {
  if (!isUrl(value)) {
    return {
      isValid: false,
      message: i18next.t('must be an URL address'),
    }
  }
}
